export {default as SystemIcon} from "../../Icons/SystemIcon/SystemIcon";



// WEBPACK FOOTER //
// ./src/components/lib/Form/Text/external.ts